function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { openModal } from "@common/actions";
import { PIN } from "@config/constants";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { isMobile } from "@common/services/helpers";
import { getChannelLogo } from "@common/utils/helpers";
import { CHANNEL_MOBILE_PX, HAS_ACCESS, KEY_ENTER, KEY_SPACE, ROUTE_ORDER_SUBSCRIPTIONS } from "@config/constants";
import { head, isString } from "lodash";
var getLogoUrl = function(channelLogo, isCentered, isOpened, isSmallMobile) {
    var logo = "";
    if (channelLogo) {
        if (isOpened && isSmallMobile) {
            logo = channelLogo.pngWhite;
        } else {
            logo = isCentered ? channelLogo.svgCentered : channelLogo.svgLeft;
        }
    }
    return logo;
};
export var ChannelLogo = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(ChannelLogo, PureComponent);
    var _super = _create_super(ChannelLogo);
    function ChannelLogo(props) {
        _class_call_check(this, ChannelLogo);
        var _this;
        _this = _super.call(this, props);
        var _this1 = _assert_this_initialized(_this);
        _define_property(_assert_this_initialized(_this), "getLogo", function() {
            var _ref = _async_to_generator(function(url, isCentered) {
                var default_channel_logo_svg, result, svgLogo, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            default_channel_logo_svg = DEFAULT_CHANNEL_LOGO[isCentered ? "center" : "left"];
                            result = {
                                svg: null,
                                imageURL: null
                            };
                            // handles the logo if it's in png format
                            if (isString(url) && url.includes(".png") && window.innerWidth <= CHANNEL_MOBILE_PX) {
                                result.imageURL = url;
                            }
                            if (!url || isString(url) && !url.includes(".svg")) {
                                result.svg = default_channel_logo_svg;
                            }
                            if (!(!result.svg && !result.imageURL && !_this1.props.restricted)) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                getChannelLogo(url, isCentered)
                            ];
                        case 2:
                            svgLogo = _state.sent();
                            result.svg = svgLogo;
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2,
                                result
                            ];
                    }
                });
            });
            return function(url, isCentered) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(_assert_this_initialized(_this), "onImageError", function() {
            if (_this.state.logo !== _this.default_channel_logo_svg) {
                _this.setState({
                    logo: _this.default_channel_logo_svg
                });
            }
        });
        /**
   * Closes the Player
   */ _define_property(_assert_this_initialized(_this), "closePlayer", function(e) {
            var _this_props = _this.props, locked = _this_props.locked, toggleFullscreen = _this_props.toggleFullscreen, closePlayer = _this_props.closePlayer, onOpening = _this_props.onOpening, channelLogo = _this_props.channelLogo;
            onOpening === null || onOpening === void 0 ? void 0 : onOpening();
            if (locked || channelLogo.access !== HAS_ACCESS) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
                return false;
            }
            if (_this.props.closePlayer) {
                if (!isMobile.any()) {
                    closePlayer();
                }
                if (_this.props.videoPlayer.video.isFullscreen) {
                    toggleFullscreen();
                }
            }
        });
        _define_property(_assert_this_initialized(_this), "closePlayerFromKeyboard", function(event) {
            var key = event.which;
            if (key === KEY_ENTER || key === KEY_SPACE) {
                event.stopPropagation();
                _this.closePlayer();
            }
        });
        _define_property(_assert_this_initialized(_this), "renderChannelLogo", function() {
            var _this_state;
            var logo = (_this_state = _this.state) === null || _this_state === void 0 ? void 0 : _this_state.logo;
            var _ref = logo || {}, svg = _ref.svg, imageURL = _ref.imageURL;
            var _this_props = _this.props, isLocked = _this_props.locked, isInSearchPage = _this_props.isInSearchPage, i18n = _this_props.i18n, channelLogo = _this_props.channelLogo, channelLogoURL = _this_props.channelLogoURL, _this_props_visible = _this_props.visible, visible = _this_props_visible === void 0 ? true : _this_props_visible;
            var locked = isLocked;
            var containerClass = locked ? "locked" : "";
            var showName = isInSearchPage;
            var content = null;
            if (svg) {
                content = /*#__PURE__*/ _jsx("span", {
                    dangerouslySetInnerHTML: {
                        __html: svg
                    }
                });
            }
            if (channelLogoURL || imageURL) {
                content = /*#__PURE__*/ _jsx("img", {
                    style: {
                        objectFit: "fill",
                        width: "100%",
                        height: "100%",
                        maxHeight: "40px"
                    },
                    src: channelLogoURL || imageURL,
                    alt: "channel logo",
                    onError: _this.onImageError
                });
            }
            return /*#__PURE__*/ _jsxs("div", {
                className: "svg-logo ".concat(containerClass),
                style: {
                    opacity: visible ? 1 : 0
                },
                children: [
                    content,
                    showName && channelLogo && /*#__PURE__*/ _jsx("p", {
                        className: "channel-logo-subtitle",
                        children: locked ? i18n.common.lockedChannel : channelLogo.name
                    })
                ]
            });
        });
        _this.state = {
            logo: {}
        };
        return _this;
    }
    _create_class(ChannelLogo, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, channelLogo, isCentered, setLogosReady, url, logo;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, channelLogo = _this_props.channelLogo, isCentered = _this_props.isCentered, setLogosReady = _this_props.setLogosReady;
                                url = getLogoUrl(channelLogo, isCentered);
                                return [
                                    4,
                                    _this.getLogo(url, isCentered)
                                ];
                            case 1:
                                logo = _state.sent();
                                _this.setState({
                                    logo: logo
                                }, function() {
                                    if (setLogosReady) {
                                        _this.props.setLogosReady();
                                    }
                                });
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, channelLogo, isCentered, url, logo;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, channelLogo = _this_props.channelLogo, isCentered = _this_props.isCentered;
                                if (!(nextProps.channelLogo !== _this.props.channelLogo)) return [
                                    3,
                                    2
                                ];
                                url = getLogoUrl(channelLogo, isCentered);
                                return [
                                    4,
                                    _this.getLogo(url, isCentered)
                                ];
                            case 1:
                                logo = _state.sent();
                                _this.setState({
                                    logo: logo
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this = this;
                return _async_to_generator(function() {
                    var _this_props, channelLogo, isCentered, isOpened, screenType, prevUrl, url, logo;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this_props = _this.props, channelLogo = _this_props.channelLogo, isCentered = _this_props.isCentered, isOpened = _this_props.isOpened, screenType = _this_props.screenType;
                                if (!prevProps.channelLogo) return [
                                    3,
                                    2
                                ];
                                prevUrl = getLogoUrl(prevProps.channelLogo, prevProps.isCentered, prevProps.isOpened, prevProps.screenType.smallMobile);
                                url = getLogoUrl(channelLogo, isCentered, isOpened, screenType.smallMobile);
                                if (!(prevUrl !== url)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getLogo(url, isCentered)
                                ];
                            case 1:
                                logo = _state.sent();
                                _this.setState({
                                    logo: logo
                                });
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, hasName = _this_props.hasName, channelLogo = _this_props.channelLogo, className = _this_props.className, isOpened = _this_props.isOpened, i18n = _this_props.i18n, isInPlayer = _this_props.isInPlayer, redirectToChannel = _this_props.redirectToChannel, isInLivePage = _this_props.isInLivePage, isInSubscriptionPage = _this_props.isInSubscriptionPage, locked = _this_props.locked, access = _this_props.access, channelName = _this_props.channelName;
                var template = null;
                var tooltipParent = "";
                if (isInPlayer) {
                    tooltipParent = "player-tooltip";
                } else if (isInLivePage) {
                    tooltipParent = "live-page-tooltip";
                } else if (isInSubscriptionPage) {
                    tooltipParent = "subscription-box-tooltip";
                } else {
                    tooltipParent = "show-slider-tooltip";
                }
                var classes = "".concat((channelLogo === null || channelLogo === void 0 ? void 0 : channelLogo.access) || channelName ? "" : "disabled", " ").concat(className || "").trim();
                var name = channelLogo && hasName ? /*#__PURE__*/ _jsx("div", {
                    className: "channel-name",
                    "aria-hidden": true,
                    children: channelLogo.name
                }) : null;
                var linkUrl = ROUTE_ORDER_SUBSCRIPTIONS;
                if (channelLogo === null || channelLogo === void 0 ? void 0 : channelLogo.access) {
                    linkUrl = "/channel/".concat(channelLogo.id);
                }
                var LinkComponent = locked || (channelLogo === null || channelLogo === void 0 ? void 0 : channelLogo.access) !== HAS_ACCESS ? "div" : Link;
                if (isOpened === false && (isMobile.any() || window.innerWidth <= CHANNEL_MOBILE_PX) || typeof redirectToChannel !== "undefined" && !redirectToChannel) {
                    template = /*#__PURE__*/ _jsxs("div", {
                        className: classes,
                        "data-for": tooltipParent,
                        "data-tip": (channelLogo === null || channelLogo === void 0 ? void 0 : channelLogo.name) || channelName,
                        tabIndex: this.props.tabIndex,
                        children: [
                            this.renderChannelLogo(),
                            name
                        ]
                    });
                } else {
                    template = /*#__PURE__*/ _jsxs(LinkComponent, {
                        to: {
                            pathname: linkUrl,
                            state: {
                                temporalUnlock: true
                            }
                        },
                        className: classes,
                        "data-tip": channelLogo ? "".concat(i18n.common.program, ": ").concat(channelLogo.name) : channelName || null,
                        "data-for": tooltipParent,
                        onClick: this.closePlayer,
                        onKeyDown: this.closePlayerFromKeyboard,
                        tabIndex: this.props.tabIndex,
                        children: [
                            this.renderChannelLogo(),
                            name
                        ]
                    });
                }
                return template;
            }
        }
    ]);
    return ChannelLogo;
}(PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n, screenType = param.screenType, videoPlayer = param.videoPlayer;
    return {
        i18n: i18n,
        screenType: screenType,
        videoPlayer: videoPlayer
    };
};
export default connect(mapStateToProps, {
    openModal: openModal
})(ChannelLogo);
